// extracted by css-extract-rspack-plugin
export default {"tab":"tab-TA84gD"};